function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 1.625c-.201 2.224-1.521 4.383-3.723 5.112.161-.299.323-.62.478-.965 1.579-.824 2.187-2.303 2.418-3.386h-1.456c.032-.244.056-.5.075-.761H13.5Zm-13 0C.702 3.85 2.021 6.008 4.223 6.737c-.161-.299-.323-.62-.478-.965-1.579-.824-2.187-2.303-2.418-3.386h1.456a14.3 14.3 0 0 1-.075-.76H.5ZM10.792.542c0 5.31-2.76 7.07-3.03 9.208H6.244C5.973 7.612 3.208 5.852 3.208.542h7.584Zm-3.957 7.07C5.813 5.846 5.407 3.586 5.402 1.625h-.92c.11 2.518 1.077 4.514 2.353 5.987Zm.944 2.68H6.226c-.109.643-.34 1.418-1.392 1.418v.748h4.333v-.748c-1.083 0-1.284-.775-1.388-1.418Z",
  fill: "#fff"
});

function SvgCollectFeesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectFeesIcon);
export default __webpack_public_path__ + "static/media/collect-fees-icon.506c192c88494f2b8da56a443413d41d.svg";
export { ForwardRef as ReactComponent };